const editor = {
  documents: "Документы",
  documentsCount: "документов",
  newDocument: "Новый документ",
  searchDocuments: "Поиск документов...",
  templates: "Шаблоны",
  saveAsTemplate: "Сохранить как шаблон",
  export: "Экспорт",
  import: "Импорт",
  copyAsMarkdown: "Копировать как Markdown",
  share: "Поделиться",
  shareDescription: "Создать ссылку только для чтения",
  createShareLink: "Создать ссылку",
  copyLink: "Копировать ссылку",
  revokeLink: "Отозвать ссылку",
  versionHistory: "История версий",
  noVersions: "Нет сохранённых версий",
  restore: "Восстановить",
  duplicate: "Дублировать",
  delete: "Удалить",
  autoSaved: "Автосохранение",
  confirmDeleteDoc: "Удалить этот документ?",
  confirmDeleteDocMessage: "Это действие нельзя отменить. Все версии и ссылки будут удалены.",
  editTemplate: "Редактировать шаблон",
  deleteTemplate: "Удалить шаблон",
  confirmDeleteTemplate: "Удалить этот шаблон?",
  confirmDeleteTemplateMessage: "Шаблон будет удалён навсегда.",
  templateDeleted: "Шаблон удалён",
  templateUpdated: "Шаблон обновлён",
  words: "слов",
  chars: "символов",
  minRead: "мин. чтения",
  lastSaved: "Последнее сохранение",
  shareExpiry: "Срок ссылки",
  noExpiry: "Без ограничений",
  expires24h: "24 часа",
  expires7d: "7 дней",
  expires30d: "30 дней",
  linkExpired: "Срок ссылки истёк",
  sourceBannerStoryMap: "Карта историй",
  sourceBannerBack: "Назад к карте историй",
  breadcrumbStoryMap: "Карта историй",
  sourceBannerBookmark: "Закладка",
  sourceBannerOpenUrl: "Открыть URL",
  loadingDocuments: "Загрузка документов...",
  noDocumentsYet: "Документов пока нет",
  untitled: "Без названия",
  saving: "Сохранение...",
  saved: "Сохранено",
  retrying: "Повторная попытка...",
  saveError: "Ошибка сохранения",
  conflictMessage: "Документ обновлён в другой вкладке",
  reload: "Перезагрузить",
  offlineSavedLocally: "Офлайн — сохранено локально",
  menu: "меню",
  placeholderSlashMenu: "Введите / для меню блоков...",
  placeholderHeading1: "Главный заголовок",
  placeholderHeading2: "Подзаголовок",
  placeholderHeading3: "Малый заголовок",
  placeholderHeading: "Заголовок",
  placeholderListItem: "Элемент списка",
  placeholderTask: "Задача",
  placeholderBlockquote: "Цитата...",
  placeholderCode: "// Пишите код здесь...",
  placeholderToggle: "Заголовок сворачиваемого...",
  placeholderCallout: "Пишите здесь...",
  timeJustNow: "только что",
  timeSecondsAgo: "{{n}} сек. назад",
  timeMinutesAgo: "{{n}} мин. назад",
  timeHoursAgo: "{{n}} ч. назад",
  categoryManagement: "Управление",
  categoryDevelopment: "Разработка",
  categoryStrategy: "Стратегия",
  categoryGeneral: "Общее",
} as const;
export default editor;
